













































































































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import FoldingCard from '@/components/FoldingCard.vue'
import AppDialog from '@/components/AppDialog.vue'
import { AcordForm } from '@/modules/AcordForm/interfaces/acord-form'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { deleteAcordForm, renameAcordForm } from '@/modules/Policy/gql/policy.gql'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import S3Handler from '@/mixins/s3'

@Component({
  components: {
    FoldingCard,
    AppDialog
  }
})
export default class AcordFormList extends mixins(S3Handler) {
  @Prop({ type: Array }) readonly acordForms!: AcordForm[]
  @Prop({ type: Boolean }) readonly unFolding!: Boolean

  acordFormTableColumn = [
    { field: 'name',
      title: 'File Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'version',
      title: 'File Version',
      slots: { default: 'version_default' },
      resizable: true
    },
    { field: 'url', title: 'Editable PDF', slots: { default: 'editable_default' }, resizable: true },
    { field: 'lockedUrl', title: 'Locked PDF', slots: { default: 'locked_default' }, resizable: true },
    { field: 'createdAt',
      title: 'Created At',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.createdAt ? dateTimeToDisplay(row.createdAt) : '-')
        ]
      }
      }
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 80 }
  ]

  targetFile: AcordForm | null = null
  renaming = false
  nullFileName = false
  renameFileName = ''
  disableConfirm = false

  deleteFileDialog = {
    show: false,
    title: 'Delete ACORD Forms',
    text: ''
  }

  get sortedAcordForms () {
    const R = this.$R
    return R.sortWith([
      R.descend(R.prop('acordFormId')),
      R.descend(R.prop('version'))
    ])(this.acordForms)
  }

  mergeCellMethod ({ row, _rowIndex, column, visibleData }: any) {
    const fields = ['name']
    const cellValue = row[column.property]
    if (cellValue && fields.includes(column.property)) {
      const prevRow = visibleData[_rowIndex - 1]
      let nextRow = visibleData[_rowIndex + 1]
      if (prevRow && prevRow['acordFormId'] === row['acordFormId']) {
        return { rowspan: 0, colspan: 0 }
      } else {
        let countRowspan = 1
        while (nextRow && nextRow['acordFormId'] === row['acordFormId']) {
          nextRow = visibleData[++countRowspan + _rowIndex]
        }
        if (countRowspan > 1) {
          return { rowspan: countRowspan, colspan: 1 }
        }
      }
    }
  }

  cellClassName (data: any) {
    if (data.column.property === 'name') {
      return 'file-name-cell'
    }
  }

  acordFormNameDisplay (fileName: string, version: number, isLocked: boolean) {
    if (version === 0) {
      return isLocked
        ? fileName + ' - Locked'
        : fileName
    } else {
      return isLocked
        ? fileName + ' - Version ' + version + ' - Locked'
        : fileName + ' - Version ' + version
    }
  }
  renameFile (e: Event, item: any) {
    e.preventDefault()
    e.stopPropagation()
    this.targetFile = Object.assign({}, item)
    this.renameFileName = item.name
    this.renaming = true
  }

  async renameConfirm (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.nullFileName = !this.renameFileName
    if (this.nullFileName) {
      return
    }
    await this.renameFileNameConfirm()
    this.renaming = false
  }

  async renameCancel (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.renaming = false
    this.renameFileName = ''
  }

  async renameFileNameConfirm () {
    if (!this.targetFile) {
      return
    }
    const { acordFormId } = this.targetFile
    try {
      await this.$apollo.mutate({
        mutation: renameAcordForm,
        variables: {
          acordId: Number(acordFormId),
          newName: this.renameFileName
        }
      })
      showNotification({
        msg: 'Update the ACORD File name successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deleteFile (e: Event, file: AcordForm) {
    e.preventDefault()
    e.stopPropagation()
    this.targetFile = file
    this.deleteFileDialog.show = true
  }

  async deleteFileConfirm () {
    if (!this.targetFile) {
      return
    }
    const { id } = this.targetFile
    this.deleteFileDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteAcordForm,
        variables: {
          acordId: Number(id)
        }
      })

      const res = result.data.deleteAcordForm
      if (res) {
        showNotification({
          msg: 'Delete ACORD Forms successfully',
          type: SnackType.Success
        })
        this.onSuccess()
        this.targetFile = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }
}
